import { useMutation } from '@tanstack/react-query'
import { useAccount } from './useAccount'
import { post } from '../api'
import { showToast } from '../utils/toast'
import { useLingui } from '@lingui/react/macro'
import { BaseURLS } from '../api/axios'
import { useDispatch } from 'react-redux'
import { setGemBalance, setIsRefreshBackpackValues } from '../store/rushbSlice'
import { useState } from 'react'

export interface ExchangedSkin {
  instanceId: string
  treasureName: string
  treasureRarity: number
  value: number
  exchangedAt: string
}

export interface GemBalanceTransaction {
  txId: number
  gemAmountChange: number
  gemBalanceBefore: number
  gemBalanceAfter: number
  description: string
}

export interface ExchangeResponse {
  exchangedCount: number
  totalGemValue: number
  newGemBalance: number
  exchangedSkins: ExchangedSkin[]
  gemBalanceTransaction: GemBalanceTransaction
}
interface BatchExchangeParams {
  instanceIds: string[]
  isBonus: boolean
}
const useRushExchange = () => {
  const dispatch = useDispatch()
  const { isLogin } = useAccount()
  const { t } = useLingui()
  const [skinLoading, setSkinLoading] = useState<string[]>()
  const { mutateAsync, isPending } = useMutation<ExchangeResponse, Error, BatchExchangeParams>({
    mutationFn: async (params: BatchExchangeParams) => {
      if (!isLogin) {
        throw new Error('User is not logged in')
      }
      if (!params?.instanceIds || params?.instanceIds?.length === 0) {
        return
      }
      try {
        setSkinLoading(params.instanceIds)
        const res = await post('/v1/batch_exchange_skins', params, { baseURL: BaseURLS.rush })
        if (!!res.successCount) {
          showToast.success(t`Successfully sold ${res.successCount} skins`)
        }
        if (res.balance?.gems) {
          dispatch(setGemBalance(res.balance.gems))
        }
        dispatch(setIsRefreshBackpackValues(true))
        // dispatch(setIsRefreshBalance(true))
        return res
      } catch (e) {
        showToast.error(t`Failed to sell skins`)
        return null
      } finally {
        setSkinLoading(undefined)
      }
    },
  })

  return {
    exchangeSkins: mutateAsync,
    isLoading: isPending,
    skinLoading,
  }
}

export default useRushExchange
